import PropTypes from 'prop-types'
import { Button } from '@calendly/ui/components/button'
import { BodyText, TitleText } from '@calendly/ui/components/typography'

import { useI18n } from 'locales'
import { formatMaskedPhoneNumber } from 'services/phone_number'

import VerificationRejectIcon from './assets/verification_reject.svg'
import VerificationSuccessIcon from './assets/verification_success.svg'
import {
  ModalBody,
  CenteredFooter,
  ConfirmationStepBody,
  IllustrationWrapper,
} from './styles'

const ILLUSTRATIONS = {
  success: VerificationSuccessIcon,
  skip: VerificationRejectIcon,
}

const NotificationIllustration = ({ variant }) => (
  <IllustrationWrapper aria-hidden>
    <img
      src={ILLUSTRATIONS[variant]}
      alt=""
      width={75}
      height={75}
    />
  </IllustrationWrapper>
)

NotificationIllustration.propTypes = {
  variant: PropTypes.oneOf(['skip', 'success']).isRequired,
}

const ConfirmationStep = ({
  illustrationVariant,
  title,
  message,
  onConfirm,
}) => {
  const { i18n } = useI18n()

  return (
    <ModalBody>
      <ConfirmationStepBody>
        <NotificationIllustration variant={illustrationVariant} />
        <TitleText level={2} size="large">
          {title}
        </TitleText>
        {message}
      </ConfirmationStepBody>
      <CenteredFooter>
        <Button
          decoration="secondary-outline"
          type="button"
          wide
          onClick={onConfirm}
        >
          {i18n.t('booking.phone_verification.ok')}
        </Button>
      </CenteredFooter>
    </ModalBody>
  )
}

ConfirmationStep.propTypes = {
  illustrationVariant: PropTypes.oneOf(['skip', 'success']).isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.node.isRequired,
  onConfirm: PropTypes.func.isRequired,
}

export const SkipSMSConfirmation = ({ onConfirm }) => {
  const { i18n } = useI18n()

  return (
    <ConfirmationStep
      illustrationVariant="skip"
      title={i18n.t('booking.phone_verification.skip_title')}
      message={(
        <BodyText size="medium" color="secondary">
          {i18n.t('booking.phone_verification.skip_message')}
        </BodyText>
      )}
      onConfirm={onConfirm}
    />
  )
}

SkipSMSConfirmation.propTypes = {
  onConfirm: PropTypes.func.isRequired,
}

export const VerifySMSSuccessConfirmation = ({ phoneNumber, onConfirm }) => {
  const { i18n } = useI18n()
  const maskedPhone = formatMaskedPhoneNumber(phoneNumber)

  return (
    <ConfirmationStep
      illustrationVariant="success"
      title={i18n.t('booking.phone_verification.verify_success_title')}
      message={(
        <BodyText size="medium" color="secondary">
          {i18n.t('booking.phone_verification.verify_success_message', { masked_phone: maskedPhone })}
        </BodyText>
      )}
      onConfirm={onConfirm}
    />
  )
}

VerifySMSSuccessConfirmation.propTypes = {
  phoneNumber: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
}
